import { memo } from 'react'
import {
    AppStateType,
    DisplayUeopt,
    GatedDisplayModes,
    GridLocation,
    SecureStateType,
} from '../../../constants/enums'
import { useAppStateSelector } from '../../Hooks/useAppState'
import { useScreenStateSelector } from '../../Hooks/useScreenState'
import { useSecureState } from '../../Hooks/useSecureState'
import Grid from '../Grid'
import Search from './Search'
import { getRows } from './helpers'
import { useHomeData } from './useHomeData'

export default memo(() => {
    const {
        noModelsVisible,
        enableOnScroll,
        onColumnCount,
        onScroll,
        ...other
    } = useHomeData()

    const { isMobile: _isMobile } = other

    const portrait = useScreenStateSelector('portrait')
    const windowWidth = useScreenStateSelector('windowWidth')

    const isMobile = _isMobile && portrait && windowWidth < 600

    const hideFeaturedModels = useAppStateSelector(
        AppStateType.APP,
        'hideFeaturedModels',
    )

    const isAuthenticated = useAppStateSelector(
        AppStateType.APP,
        'authenticated',
    )

    const { ageGateActive } = useSecureState(SecureStateType.AGE_VERIFICATION)
    const displayConfig = useSecureState(SecureStateType.DISPLAY_CONFIG)
    const forceAvatars =
        ageGateActive && displayConfig?.settings !== GatedDisplayModes.preview

    return (
        <Search noModelsVisible={noModelsVisible}>
            <Grid
                displayTypeButtonProps={{
                    showModelCount: true,
                    offset:
                        !hideFeaturedModels && !isAuthenticated && isMobile
                            ? 102
                            : 8,
                }}
                gridLocation={GridLocation.Home}
                enableOnScroll={enableOnScroll}
                onColumnCount={onColumnCount}
                onScroll={onScroll}
                getRows={getRows}
                data={other}
                {...(forceAvatars
                    ? { displayOverride: DisplayUeopt.default }
                    : {})}
            />
        </Search>
    )
})
